import type { BackEnd } from '@cdab/scania/qpr/interactor'
import { getClient } from './client'

export function useBackend(): BackEnd {
  const client = getClient()

  return client
}
